import { useState, FormEvent } from 'react'
import { verifyPassword, writeSession } from '../lib/auth'
import { Logo } from './Logo'

export function Login({ onSignedIn }: { onSignedIn: () => void }) {
  const [password, setPassword] = useState('')
  const [error, setError] = useState<string | null>(null)
  const [busy, setBusy] = useState(false)

  async function submit(e: FormEvent) {
    e.preventDefault()
    setError(null)
    setBusy(true)
    try {
      const ok = await verifyPassword(password)
      if (!ok) {
        setError('Wrong password.')
        return
      }
      writeSession(password)
      onSignedIn()
    } catch (err) {
      setError((err as Error).message)
    } finally {
      setBusy(false)
    }
  }

  return (
    <div className="min-h-screen flex items-center justify-center p-6">
      <form
        onSubmit={submit}
        className="w-full max-w-sm bg-slate-900 border border-slate-800 rounded-xl p-8 space-y-6"
      >
        <div className="flex flex-col items-center gap-4">
          <Logo className="h-10 w-auto" />
          <div className="text-center">
            <h1 className="text-lg font-semibold">Banking reconciliation</h1>
            <p className="text-slate-400 text-xs mt-1">Sign in to continue.</p>
          </div>
        </div>

        <label className="block text-sm">
          Password
          <input
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            className="mt-1 w-full rounded bg-slate-800 border border-slate-700 px-3 py-2"
            autoComplete="current-password"
            autoFocus
          />
        </label>

        {error && <div className="text-red-400 text-sm">{error}</div>}

        <button
          type="submit"
          disabled={busy || !password}
          className="w-full rounded bg-indigo-600 hover:bg-indigo-500 disabled:opacity-50 px-3 py-2 text-sm font-medium"
        >
          {busy ? 'Checking…' : 'Sign in'}
        </button>
      </form>
    </div>
  )
}
